export default "__VITE_ASSET__DJoImTmT__"